import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '../../services/auth.service';
import { InvitationDetails } from '../../shared/models';

@Component({
  standalone: false,
  selector: 'app-register',
  templateUrl: './register.component.html',
})
export class RegisterComponent implements OnInit {
  token = '';
  firstName = '';
  lastName = '';
  password = '';
  confirmPassword = '';
  invitation?: InvitationDetails;
  errorMessage = '';
  isLoading = true;
  isSubmitting = false;

  constructor(
    private readonly authService: AuthService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {
  }

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParams['token'] as string | undefined ?? '';

    if (!this.token) {
      this.errorMessage = 'Invitation token is missing';
      this.isLoading = false;
      return;
    }

    this.authService.getInvitation(this.token).subscribe({
      next: (invitation) => {
        this.invitation = invitation;
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.errorMessage = error.error?.message ?? 'Invitation is invalid or expired';
        this.isLoading = false;
      },
    });
  }

  onSubmit(): void {
    if (this.password !== this.confirmPassword) {
      this.errorMessage = 'Passwords do not match';
      return;
    }

    this.errorMessage = '';
    this.isSubmitting = true;

    this.authService.acceptInvitation({
      token: this.token,
      firstName: this.firstName,
      lastName: this.lastName,
      password: this.password,
    }).subscribe({
      next: () => {
        void this.router.navigateByUrl('/');
      },
      error: (error: HttpErrorResponse) => {
        this.errorMessage = error.error?.message ?? 'Unable to accept invitation';
        this.isSubmitting = false;
      },
    });
  }
}
